import React from "react";
import { Button } from "@material-ui/core";
import ApplicantPDF from "./ApplicantPDF";
import moment from "moment";

const ApplicantInfo = ({ data, isLoadingID, }) => {




  return (
    <div className='Navigationsubcontainer'>
      <div className='Navigationsubcontainersub1'>
        <div className='Experience-tabs-container'>
          <div className='Experience-tabs'>Profile Info</div>
          <div className='subspace-btn-container1'>
            <div className='Notice'>
              <div className='Notice1'>
                <div className='span-text'>
                  <h5 className='first-title'>First Name</h5>
                  <span className='first-title-sub'>
                    {isLoadingID ? (
                      <p className=' placeholder-glow  '>
                        <span
                          className='placeholder  '
                          style={{ width: "10rem" }}
                        ></span>
                      </p>
                    ) : !data?.firstName ? (
                      "N/A"
                    ) : (
                      data?.firstName
                    )}
                  </span>
                </div>
                <div className='span-text'>
                  <h5 className='first-title'>Last Name</h5>
                  <span className='first-title-sub'>
                    {" "}
                    {isLoadingID ? (
                      <p className=' placeholder-glow  '>
                        <span
                          className='placeholder  '
                          style={{ width: "10rem" }}
                        ></span>
                      </p>
                    ) : !data?.LastName ? (
                      "N/A"
                    ) : (
                      data?.LastName
                    )}
                  </span>
                </div>
                <div className='span-text'>
                  <h5 className='first-title'>Phone Number</h5>
                  <span className='first-title-sub'>
                    {isLoadingID ? (
                      <p className=' placeholder-glow  '>
                        <span
                          className='placeholder  '
                          style={{ width: "10rem" }}
                        ></span>
                      </p>
                    ) : !data?.phoneNumber ? (
                      "N/A"
                    ) : (
                      data?.phoneNumber
                    )}
                  </span>
                </div>
              </div>

              <div className='Notice2'>
                <div className='span-text'>
                  <h5 className='first-title'>Middle Name</h5>
                  <span className='first-title-sub'>
                    {isLoadingID ? (
                      <p className=' placeholder-glow  '>
                        <span
                          className='placeholder  '
                          style={{ width: "10rem" }}
                        ></span>
                      </p>
                    ) : !data?.middleName ? (
                      "N/A"
                    ) : (
                      data?.middleName
                    )}
                  </span>
                </div>
                <div className='span-text'>
                  <h5 className='first-title'>Location</h5>
                  <span className='first-title-sub'>
                    {isLoadingID ? (
                      <p className=' placeholder-glow  '>
                        <span
                          className='placeholder  '
                          style={{ width: "10rem" }}
                        ></span>
                      </p>
                    ) : !data?.location ? (
                      "N/A"
                    ) : (
                      data?.location
                    )}
                  </span>
                </div>
                <div className='span-text'>
                  <h5 className='first-title'>Email</h5>
                  <span className='first-title-sub'>
                    {isLoadingID ? (
                      <p className=' placeholder-glow  '>
                        <span
                          className='placeholder  '
                          style={{ width: "10rem" }}
                        ></span>
                      </p>
                    ) : !data?.email ? (
                      "N/A"
                    ) : (
                      data?.email
                    )}
                  </span>
                </div>
              </div>
            </div>

            {data?.WorkExperience?.map((item, index) => (
              <div key={index}>
                <div className='Experience-tabs'>
                  Work Experience {index + 1}
                </div>
                <h5>
                  <div className='Notice'>
                    <div className='Notice1'>
                      <div className='span-text'>
                        <h5 className='first-title'>Company</h5>
                        <span className='first-title-sub'>
                          {isLoadingID ? (
                            <p className=' placeholder-glow  '>
                              <span
                                className='placeholder  '
                                style={{ width: "10rem" }}
                              ></span>
                            </p>
                          ) : !item.company ? (
                            "N/A"
                          ) : (
                            item?.company
                          )}
                        </span>
                      </div>
                      <div className='span-text'>
                        <h5 className='first-title'>Currently Working </h5>
                        <span className='first-title-sub'>
                          {isLoadingID ? (
                            <p className=' placeholder-glow  '>
                              <span
                                className='placeholder  '
                                style={{ width: "10rem" }}
                              ></span>
                            </p>
                          ) : !data?.currentlyWorking ? (
                            "N/A"
                          ) : (
                            data?.email
                          )}
                        </span>
                      </div>
                    </div>

                    <div className='Notice2'>
                      <div className='span-text'>
                        <h5 className='first-title'>Start Date</h5>
                        <span className='first-title-sub'>
                          {isLoadingID ? (
                            <p className=' placeholder-glow  '>
                              <span
                                className='placeholder  '
                                style={{ width: "10rem" }}
                              ></span>
                            </p>
                          ) : !moment(item?.startDate).format("DD-MM-YYYY") ? (
                            "N/A"
                          ) : (
                            moment(item?.startDate).format("DD-MM-YYYY")
                          )}
                        </span>
                      </div>
                      <div className='span-text'>
                        <h5 className='first-title'>End Date</h5>
                        <span className='first-title-sub'>
                          {isLoadingID ? (
                            <p className=' placeholder-glow  '>
                              <span
                                className='placeholder'
                                style={{ width: "10rem" }}
                              ></span>
                            </p>
                          ) : !moment(item?.endDate).format("DD-MM-YYYY") ? (
                            "N/A"
                          ) : (
                            moment(item?.endDate).format("DD-MM-YYYY")
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                </h5>
              </div>
            ))}

            {data?.Education?.map((item, index) => (
              <div key={index}>
                <div className='Experience-tabs'>Education {index + 1}</div>
                <div className='Notice'>
                  <div className='Notice1'>
                    <div className='span-text'>
                      <h5 className='first-title'>School</h5>
                      <span className='first-title-sub'>
                        {isLoadingID ? (
                          <p className=' placeholder-glow  '>
                            <span
                              className='placeholder  '
                              style={{ width: "10rem" }}
                            ></span>
                          </p>
                        ) : !item?.school ? (
                          "N/A"
                        ) : (
                          item?.school
                        )}
                      </span>
                    </div>
                    <div className='span-text'>
                      <h6 className='first-title'>Start Date</h6>
                      <span className='first-title-sub'>
                        {" "}
                        {isLoadingID ? (
                          <p className=' placeholder-glow  '>
                            <span
                              className='placeholder  '
                              style={{ width: "10rem" }}
                            ></span>
                          </p>
                        ) : !moment(item?.startDate).format("DD-MM-YYYY") ? (
                          "N/A"
                        ) : (
                          moment(item?.startDate).format("DD-MM-YYYY")
                        )}
                      </span>
                    </div>
                  </div>
                  <div className='Notice2'>
                    <div className='span-text'>
                      <h5 className='first-title'>End Date</h5>
                      <span className='first-title-sub'>
                        {isLoadingID ? (
                          <p className=' placeholder-glow  '>
                            <span
                              className='placeholder  '
                              style={{ width: "10rem" }}
                            ></span>
                          </p>
                        ) : !moment(item?.endDate).format("DD-MM-YYYY") ? (
                          "N/A"
                        ) : (
                          moment(item?.endDate).format("DD-MM-YYYY")
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}

            <div className='Experience-tabs'>
              Job
              <div className='subspace-btn-container1'>
                <div className='Notice'>
                  <div className='Notice1'>
                    <div className='span-text'>
                      <h6 className='first-title'>Role</h6>
                      <p>{data?.Job?.jobRole}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div className='Navigationsubspace' />
      <div className='Navigationsubcontainersub2'>
        <div className='priview-btn'>
          <div className='Experience-tabs'>Resume Preview</div>
        </div>
        <div className='subspace-btn-container'>
          <ApplicantPDF data={data} />
        </div>
      </div>
    </div>
  );
};

export default ApplicantInfo;
